import './environment/validate.fx';
import './environment/muteWarnings.fx';

// TODO: Bacon: This is a tricky side-effect
// load expo-asset immediately to set a custom `source` transformer in React Native
import 'expo-asset';
